import api from './index'
import type { V1ApiResponse } from '@/types'

export const ADVERT_MEDIA_TYPE_IMAGE = 1
export const ADVERT_MEDIA_TYPE_VIDEO = 2

export interface AdvertMedia {
  mediaId: number
  mediaUrl: string
  mediaType?: number
  sort: number
}

export interface AdvertMaterial {
  materialId: number
  materialName: string
  jumpUrl?: string
  jumpParam?: Record<string, unknown> | string | null
  effectiveState: boolean
  sort: number
  media: AdvertMedia[]
}

export interface QueryAdvertsData {
  platformType: number
  advertSpaceCode: string
  advertSpaceName: string
  limitedQuantity: number
  materials: AdvertMaterial[]
}

export const advertApi = {
  query: (advertSpaceCode: string): Promise<V1ApiResponse<QueryAdvertsData>> =>
    api.get('/v1/adverts', {
      params: { advertSpaceCode },
      noAuthRedirect: true,
    } as any),
}

export default advertApi
